import { BACKEND } from "../variables.js";
import axios from "axios";

const BASE = BACKEND + "/campaigns";
const call = (path, payload) =>
  axios({
    method: "POST",
    url: BASE + path,
    data: payload.data,
    headers: { Authorization: payload.token },
  });

/** Communications: bulk email campaigns to clients. */
export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    LIST_CAMPAIGNS: (s, p) => call("/list", p),
    GET_CAMPAIGN: (s, p) => call("/get", p),
    SAVE_CAMPAIGN: (s, p) => call("/save", p),
    CAMPAIGN_AUDIENCE: (s, p) => call("/audience", p),
    SEND_CAMPAIGN: (s, p) => call("/send", p),
    RESEND_CAMPAIGN: (s, p) => call("/resend", p),
    CAMPAIGN_RECIPIENTS: (s, p) => call("/recipients", p),
    DELETE_CAMPAIGN: (s, p) => call("/delete", p),
    DUPLICATE_CAMPAIGN: (s, p) => call("/duplicate", p),
  },
};
